import { useSalesforceService } from '@/hooks/use-salesforce-service.hook';
import { useGetSalesforceLeadPayload } from '@/services/hooks/use-get-salesforce-lead-payload.hook';
import { hearDigitsEventsConfig, sendEventToHost } from 'hx-analytics';
export function useTrackLead() {
    var sendTestCompleted = useSalesforceService().sendTestCompleted;
    var data = useGetSalesforceLeadPayload();
    var leads = hearDigitsEventsConfig.leads;
    function trackLead() {
        if (!(leads === null || leads === void 0 ? void 0 : leads.enabled))
            return;
        var isModeBoth = leads.mode === 'both';
        if (isModeBoth || leads.mode === 'internal')
            sendTestCompleted();
        if ((isModeBoth || leads.mode === 'host') && data)
            sendEventToHost({ event: data, eventType: 'lead' });
    }
    return trackLead;
}
